import React from "react";
import {  useSelector } from "react-redux";
import { AppState } from "../config/redux/reducers";
import {
  fetchCarrefourDeliveryStatuses,
  consignmentReplanning,
  fetchDeliveryReasons,
} from "./redux/carrefourDeliverySlice";
import { createConsignmentReplanningPayload } from "../mocks/SharedTransform/response.transforms";
import OrderDetailsEdit from "../SharedComponent/components/orderDetailsEdit";

interface CarrefourDeliveryOrderDetailsEditProps {
  open: boolean;
  consignment: any;
  isExpress?: any;
  closePopup: () => void;
}

const CarrefourDeliveryOrderDetailsEdit = (
  props: CarrefourDeliveryOrderDetailsEditProps
) => {
  const { open, consignment, closePopup } = props;

  const {
    carrefourDeliveryStatuses,
    deliveryReasons,
    reasonsDropdownList,
    chdReplanningConsignmentSuccess,
    consignmentDataAfterReplanning,
    deliverySlotListCHD,
  } = useSelector((state: AppState) => state.carrefourDelivery);
  

  return (
   <OrderDetailsEdit
    open={open}
    consignment={consignment}
    closePopup={closePopup}
    reduxStates={{
      statuses: carrefourDeliveryStatuses,
      deliveryReasons,
      reasonsDropdownList,
      replanningConsignmentSuccess: chdReplanningConsignmentSuccess,
      consignmentDataAfterReplanning,
      deliverySlotList:deliverySlotListCHD,
    }}
    transforms={{
      createOrderReplanningPayload: createConsignmentReplanningPayload,
    }}
    actions={{
      orderReplanning: consignmentReplanning, 
      fetchStatuses: fetchCarrefourDeliveryStatuses,
      fetchDeliveryReasons
    }}  />

  );
};

export default CarrefourDeliveryOrderDetailsEdit;
